// The form does not work out a repeating expense's dates. It asks the server
// (POST /expenses/schedule-preview) and shows exactly what comes back, so the
// preview cannot differ from what a save creates. (ZEN-704)

// What to ask, or null when there is nothing to ask yet.
export function schedulePreviewRequest(recur, transactionDate, day) {
  if (!recur?.enabled || !transactionDate) return null;
  const body = {
    transaction_date: transactionDate,
    recurrence_interval_months: recur.intervalMonths,
    recurrence_day: day,
  };
  if (recur.endType === "date") {
    if (!recur.endDate) return null;
    body.recurrence_end_date = recur.endDate;
  } else {
    body.recurrence_occurrences = recur.occurrences;
  }
  return body;
}

// The server's answer as local dates at noon (a date, never a moment), with
// `overflow` set when the end date needs more entries than one schedule holds.
export function schedulePreviewDates(answer) {
  const dates = (answer?.dates || []).map(d => new Date(d + "T12:00:00"));
  dates.overflow = answer?.too_many === true;
  return dates;
}

// The stored answer, but only if it was asked about exactly these fields.
export function answerFor(stored, askKey) {
  return stored && askKey && stored.askedFor === askKey ? stored.data : null;
}

// The date a new expense is priced for. A repeating expense is priced for its
// first payment date, the date its first expense is saved under; "" while the
// server has not yet said what that date is, or says the schedule creates
// nothing. It is not priced for the typed date in the meantime. (ZEN-708)
export function pricingDate(askKey, stored, transactionDate) {
  if (!askKey) return transactionDate || "";
  if (!stored || stored.askedFor !== askKey) return "";
  return stored.data?.dates?.[0] || "";
}

// Shown when a reservation is chosen on a repeating expense. (ZEN-708; wording
// approved by the owner, 2026-10-13.)
export const AOTC_REPEATING_NOTE = "Only the first expense this creates is reserved for AOTC. To reserve a later month, open that expense and set it there.";
